export default __webpack_public_path__ + "static/media/phone.c631d435.png";